(function () {
  const WIDGET_SEL = "#judgeme_product_reviews";
  const REVIEW_SEL = ".jm-review-item";
  const CARD_SEL   = ".jm-product-variant-card";

  function getCurrentProductInfo() {
    const h1 = document.querySelector("h1");
    const title = h1 ? h1.textContent.trim() : document.title.trim();

    const canonical = document.querySelector('link[rel="canonical"]');
    const url = canonical ? canonical.href : window.location.href;

    const ogImg = document.querySelector('meta[property="og:image"]');
    const img = ogImg ? ogImg.content : "";

    return { title, url, img };
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

function makeCardEl({ title, url, img }) {
  const safeTitle = escapeHtml(title);
  const safeUrl   = escapeHtml(url);
  const safeImg   = escapeHtml(img);

  const aria = `View ${safeTitle} product page`;

  const card = document.createElement("div");
  card.className = "jm-box jm-box--inherit-color jm-product-variant-card cx-jm-product-card";

  card.innerHTML = `
    <div class="jm-product-variant-card__inner cx-jm-product-card__inner">
      <a class="jm-frame jm-product-variant-card__thumbnail cx-jm-product-card__thumb"
         href="${safeUrl}"
         aria-label="${aria}">
        ${safeImg ? `<img src="${safeImg}" alt="${safeTitle}" loading="lazy" decoding="async" />` : ``}
      </a>

      <div class="jm-stack jm-stack--space-0 jm-product-variant-card__content cx-jm-product-card__content">
        <p class="jm-text jm-product-variant-card__label cx-jm-product-card__label">Review for</p>

        <a class="jm-text jm-product-variant-card__product-link cx-jm-product-card__link"
           href="${safeUrl}"
           aria-label="${aria}">
          ${safeTitle}
        </a>
      </div>
    </div>
  `;

  return card;
}


  function placeCard(reviewEl, cardEl) {
    // Put the card UNDER the review text (same place the good ones appear)
    // We try a few likely containers first, otherwise append to the review.
    const content =
      reviewEl.querySelector(".jm-review-content") ||
      reviewEl.querySelector(".jm-review-content__body") ||
      reviewEl.querySelector(".jm-review-content__body-content") ||
      reviewEl;

    // If content is inside the review, insert after it; otherwise fallback to append
    if (content !== reviewEl && content.parentNode === reviewEl) {
      content.insertAdjacentElement("afterend", cardEl);
    } else {
      reviewEl.appendChild(cardEl);
    }
  }

  function ensureCardOnReview(reviewEl, productInfo) {
    // If Judge.me already rendered a card (other products in the group), keep it.
    if (reviewEl.querySelector(CARD_SEL)) return;

    // Inject missing card (this is for "current product" reviews)
    const cardEl = makeCardEl(productInfo);
    placeCard(reviewEl, cardEl);
  }

  function run() {
    const widget = document.querySelector(WIDGET_SEL);
    if (!widget) return;

    const productInfo = getCurrentProductInfo();
    widget.querySelectorAll(REVIEW_SEL).forEach(r => ensureCardOnReview(r, productInfo));
  }

  document.addEventListener("DOMContentLoaded", run);

  const obs = new MutationObserver(() => run());
  document.addEventListener("DOMContentLoaded", function () {
    const widget = document.querySelector(WIDGET_SEL);
    if (widget) obs.observe(widget, { childList: true, subtree: true });
  });
})();